<template>
    <div class="h-full userInfo-box">
      <div  class="title">
        <el-row :gutter="4">
              <el-col :span="9"><div class="grid-content ep-bg-purple" /></el-col>
                <el-col :span="6"><div class="grid-content ep-bg-purple" style="text-align: center;" />个人信息</el-col>
                <el-col :span="9"><div class="grid-content ep-bg-purple" /></el-col>
              </el-row>
      </div>
      <div v-show="!userName" style="text-align: center;">
        <span class="loading" v-loading="loading" 
          background="transparent"
         element-loading-background="transparent">数据加载中</span>
      </div>
      <div v-show="userName">
        <div class="name">
          <el-row :gutter="4">
                  <el-col :span="1"><div class="grid-content ep-bg-purple" />姓名</el-col>
                  <el-col :span="6"><div class="grid-content ep-bg-purple" />{{userName}}</el-col>
                </el-row>
        </div>
        <div class="info">
          <el-row :gutter="4" class="info_item">
                  <el-col :span="2"><div class="grid-content ep-bg-purple" />手机号</el-col>
                  <el-col :span="4"><div class="grid-content ep-bg-purple" />{{phone}}</el-col>
                  <el-col :span="2"><div class="grid-content ep-bg-purple" />邮箱</el-col>
                  <el-col :span="4"><div class="grid-content ep-bg-purple" />{{email}}</el-col>
            </el-row>
            <el-row :gutter="4" class="info_item">
                  <el-col :span="2"><div class="grid-content ep-bg-purple" />公司名称</el-col>
                  <el-col :span="3"><div class="grid-content ep-bg-purple" />{{companyName}}</el-col>

            </el-row>
            <el-row :gutter="4" class="info_item">
                  <el-col :span="2"><div class="grid-content ep-bg-purple" />注册时间</el-col>
                  <el-col :span="4"><div class="grid-content ep-bg-purple" />{{startTime}}</el-col>
                  <el-col :span="2"><div class="grid-content ep-bg-purple" />账号有效期</el-col>
                  <el-col :span="4"><div class="grid-content ep-bg-purple" />{{endTime}}</el-col>
            </el-row>
        </div>
      </div>
    </div>
</template>
<script setup>
import ReportItem from '@/components/reportItem'
import CitySelect from '@/components/citySelect'
import {onMounted, ref, watch,onBeforeMount} from "vue";
import request from "@/service/request";
import { getReport, getreportCollectLists, addReportCollects, 
cancelCollect, getReportLists, cancelReports,getClientHeadData } from "@/service/api";

const userName = ref()
const phone = ref()
const email = ref()
const companyName = ref()
const startTime = ref()
const endTime = ref()
const loading = ref(true)

const getUserInfo= async () => {
  let { data } = await request({
    url: getClientHeadData,
    data: {
      filterateaear: false
    }
  })
  userName.value = data.userName || ''
  phone.value = data.phoneNumber || '无'
  email.value = data.email || '无'
  companyName.value = data.companyName || '无'
  startTime.value = data.startTime || ''
  endTime.value = data.endTime || ''
console.log('0000000000000000000000000000000000');
console.log(data);
// console.log(data.provinces);
  
  
  
  console.log('0000000000000000000000000000000000');
  
}

// onMounted(() => {
//   console.log('abc');
//     getUserInfo()
//     // window.addEventListener('resize', handleResize);
// });
// onBeforeMount(() => {
//   getUserInfo()
//        console.log('Component about to mount');
//    });
// onBeforeRouteEnter((to, from, next) => {
//   console.log('1111');
//   getUserInfo()
//     next();
//   })
</script>

<style lang="less">
.userInfo-box {
  font-size: 15px;
  background: url(/img/u_agg_bg.92d7457f.png) no-repeat;
}
.name {
  height: 60px;
  margin: 0px 60px 15px 60px;
  line-height: 60px;
  /* background-color: #fff; */
  border-bottom: 1px #ccc solid;
      
}
.info {
  margin-left: 60px;
  margin-right: 60px;
}
.info_item {
  margin-bottom: 20px;
}
.title .el-col-6 {
  text-align: center;
  font-size: 22px;  
  font-weight: bold;
  color: #333;
}
.title {
      padding-top: 20px;
    text-align: center;
    margin-bottom: 35px;
}
.loading {
    height: 160px;
    text-align: center;
    line-height: 160px;
}
</style>